var _path, _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmYourData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 706,
    height: 666,
    viewBox: "0 0 706 666",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_91_2004",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -50,
    y: -39,
    width: 848,
    height: 750
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M797.182 -38.9475H-49.8708V710.759H797.182V-38.9475Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_91_2004)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M664.998 452.093C634.829 513.299 581.327 576.755 516.226 588.955C417.858 607.387 395.52 689.701 227.712 659.348C201.546 654.614 177.761 647.281 156.27 637.769C144.713 632.655 133.829 626.907 123.602 620.586C30.801 563.305 -7.82734 459.428 1.30378 357.359C13.313 223.128 106.144 170.801 165.941 140.889C225.739 110.976 310.944 -24.5328 476.166 3.89482C501.354 8.24569 526.102 15.4334 549.61 26.0314C603.272 50.1816 655.179 94.6752 681.054 153.03C682.997 157.41 684.808 161.878 686.518 166.406C719.756 254.966 706.139 368.663 665.012 452.109L664.998 452.093Z",
    fill: "#DFFF02",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M625.124 437.163C598.805 490.696 552.132 546.197 495.34 556.866C409.528 572.988 390.041 644.983 243.651 618.435C220.826 614.295 200.077 607.88 181.328 599.561C171.247 595.088 161.752 590.061 152.83 584.533C71.8739 534.433 38.176 443.578 46.1416 354.305C56.618 236.902 137.6 191.135 189.765 164.973C241.93 138.811 316.26 20.2901 460.393 45.1538C482.366 48.9592 503.956 55.2459 524.463 64.5152C571.276 85.6378 616.558 124.553 639.13 175.592C640.825 179.423 642.405 183.332 643.897 187.291C672.892 264.749 661.013 364.192 625.136 437.176L625.124 437.163Z",
    fill: "#DFFF02",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.641 414.838C545.969 456.865 509.312 500.437 464.706 508.813C397.307 521.47 382.001 577.991 267.024 557.149C249.096 553.899 232.799 548.863 218.074 542.332C210.156 538.82 202.698 534.874 195.691 530.533C132.106 491.202 105.639 419.875 111.895 349.789C120.124 257.62 183.729 221.69 224.701 201.151C265.672 180.612 324.052 87.5648 437.258 107.085C454.516 110.072 471.473 115.007 487.58 122.284C524.347 138.867 559.913 169.419 577.641 209.487C578.973 212.495 580.214 215.563 581.385 218.672C604.159 279.482 594.829 357.551 566.65 414.849L566.641 414.838Z",
    fill: "#DFFF02",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.643 584.899H629.67",
    stroke: "#BBBBBB",
    strokeWidth: 1.4081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5289 584.899H601.896",
    stroke: "#BBBBBB",
    strokeWidth: 1.4081,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.793 101.014C448.346 104.812 459.146 109.166 459.146 109.166C459.254 109.214 459.827 101.122 459.803 100.604C459.553 94.646 455.582 83.2977 449.195 81.5249C444.602 80.2465 440.32 83.5992 439.566 88.1458C438.789 92.7887 441.754 97.7695 444.78 101.001L444.793 101.014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.926 149.83C551.998 149.927 556.901 143.499 557.165 143.065C560.215 137.951 563.11 126.277 558.756 121.248C555.621 117.63 550.227 118.04 547.094 121.417C543.9 124.854 543.65 130.655 544.414 135.045C545.3 140.194 551.926 149.83 551.926 149.83Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.332 124.481C594.555 121.225 583.827 126.495 579.497 130.559C579.126 130.909 573.9 137.071 574.007 137.119C574.007 137.119 574.114 137.168 574.138 137.168C572.439 137.988 570.621 138.88 568.66 139.905C565.048 141.823 560.993 144.018 556.735 146.719C552.477 149.396 547.92 152.435 543.399 156.065C538.865 159.695 534.295 163.76 530.109 168.547C530.061 168.596 530.026 168.668 529.978 168.716C530.768 166.931 532.813 161.866 532.932 161.456C534.535 155.716 534.271 143.68 528.759 139.99C524.786 137.336 519.692 139.17 517.563 143.258C515.386 147.431 516.666 153.087 518.543 157.115C520.661 161.661 528.89 168.716 529.536 169.271C525.589 173.878 521.917 178.919 518.484 184.237C516.51 187.276 514.62 190.388 512.767 193.547C513.401 191.979 513.962 190.58 514.01 190.375C515.613 184.635 515.349 172.599 509.835 168.909C505.864 166.256 500.77 168.089 498.641 172.177C496.464 176.35 497.744 182.006 499.621 186.034C501.523 190.122 508.413 196.273 510.266 197.877C509.573 199.095 508.855 200.301 508.161 201.519C504.824 207.368 501.523 213.217 498.114 218.861C496.917 220.85 495.65 222.756 494.407 224.686C494.968 223.299 495.435 222.116 495.482 221.936C497.085 216.195 496.822 204.16 491.309 200.47C487.337 197.816 482.242 199.649 480.113 203.738C477.936 207.91 479.216 213.566 481.093 217.595C482.911 221.502 489.228 227.23 491.405 229.148C490.064 231.077 488.725 233.007 487.349 234.816C486.381 236.021 485.519 237.265 484.478 238.422C483.474 239.592 482.469 240.75 481.476 241.907C479.491 244.053 477.457 246.272 475.459 248.311C474.085 249.746 472.757 251.072 471.417 252.423C472.637 250.457 474.945 246.562 475.102 246.213C476.728 242.607 477.947 236.131 477.146 230.872C477.386 230.342 477.588 229.788 477.721 229.22C478.82 224.747 476.238 219.958 471.512 219.271C464.958 218.319 456.824 227.133 454.229 232.488C454.073 232.802 452.794 236.42 452.028 238.711C452.279 237.289 452.531 235.926 452.771 234.454C453.261 231.56 453.668 228.665 454.121 225.553C454.289 224.047 454.456 222.515 454.624 220.972C454.828 219.439 454.839 217.812 454.959 216.208C455.15 212.493 455.162 208.731 455.102 204.932C457.614 205.354 466.549 206.753 470.844 205.632C475.113 204.522 480.257 201.917 482.062 197.563C483.821 193.306 481.99 188.181 477.422 186.782C471.082 184.84 461.716 192.317 458.355 197.213C458.141 197.515 456.119 201.302 455.042 203.412C454.983 201.133 454.935 198.854 454.804 196.55C454.421 189.893 453.822 183.164 453.261 176.446C453.08 174.384 452.937 172.334 452.782 170.284C453.679 170.441 464.265 172.334 469.072 171.08C473.354 169.97 478.487 167.365 480.292 163.012C482.051 158.755 480.22 153.629 475.651 152.23C469.311 150.289 459.946 157.766 456.585 162.662C456.334 163.036 453.428 168.487 452.758 169.91C452.411 165.388 452.112 160.877 451.992 156.427C451.824 150.277 451.992 144.235 452.59 138.398C453.009 138.47 464.049 140.496 468.976 139.218C473.247 138.108 478.391 135.503 480.196 131.15C481.955 126.893 480.124 121.767 475.555 120.368C469.216 118.427 459.85 125.904 456.489 130.8C456.263 131.126 454.049 135.274 453.045 137.276C452.842 137.216 452.878 137.228 452.686 137.168C453.404 130.921 454.863 124.951 456.513 119.44C457.458 116.244 458.547 113.241 459.672 110.347C461.692 110.938 470.939 113.518 475.507 112.867C479.874 112.24 485.268 110.214 487.541 106.089C489.753 102.049 488.486 96.7551 484.108 94.8618C478.019 92.2327 467.901 98.6245 464.026 103.111C463.81 103.352 461.944 106.077 460.604 108.079C461.13 106.777 461.644 105.426 462.171 104.196C464.145 99.553 466.226 95.4286 468.103 91.7865C469.192 89.7243 470.208 87.8792 471.177 86.1666C473.463 85.6963 482.625 83.7185 486.296 81.0654C489.885 78.4725 493.748 74.1671 493.88 69.4638C494 64.857 490.447 60.7325 485.699 61.0943C479.096 61.5888 473.032 71.9602 471.645 77.7489C471.525 78.2554 470.544 86.2993 470.663 86.2752C470.663 86.2752 470.772 86.2511 470.796 86.2511C469.827 87.8792 468.81 89.6399 467.733 91.5815C465.772 95.1874 463.595 99.2756 461.513 103.895C459.42 108.501 457.279 113.567 455.509 119.102C453.715 124.65 452.124 130.583 451.251 136.902C451.251 136.975 451.251 137.047 451.227 137.119C450.916 135.19 449.852 129.823 449.719 129.425C447.914 123.745 441.12 113.856 434.493 113.844C429.721 113.844 426.48 118.21 426.935 122.792C427.401 127.484 431.563 131.487 435.331 133.803C439.577 136.42 450.306 137.722 451.155 137.831C450.389 143.861 450.078 150.12 450.126 156.463C450.139 160.093 450.27 163.747 450.45 167.402C450.126 165.737 449.815 164.266 449.756 164.061C447.949 158.381 441.144 148.492 434.53 148.48C429.757 148.48 426.515 152.845 426.97 157.428C427.436 162.119 431.598 166.123 435.366 168.439C439.194 170.79 448.308 172.093 450.725 172.406C450.808 173.805 450.868 175.216 450.964 176.615C451.382 183.345 451.824 190.062 452.064 196.671C452.148 198.998 452.148 201.289 452.159 203.593C451.872 202.121 451.61 200.879 451.55 200.699C449.743 195.019 442.95 185.129 436.324 185.117C431.551 185.117 428.309 189.483 428.764 194.066C429.231 198.757 433.394 202.761 437.16 205.077C440.809 207.32 449.218 208.599 452.088 208.984C452.029 211.336 451.968 213.687 451.8 215.967C451.658 217.522 451.622 219.017 451.382 220.573C451.179 222.116 450.988 223.637 450.784 225.144C450.294 228.039 449.815 231.017 449.277 233.827C448.918 235.78 448.536 237.638 448.153 239.519C448.093 237.204 447.89 232.67 447.83 232.295C446.897 226.41 441.671 215.593 435.127 214.567C430.414 213.832 426.552 217.655 426.312 222.261C426.073 226.964 429.578 231.56 432.963 234.43C436.683 237.59 446.658 240.448 447.914 240.798C447.28 243.897 446.621 246.9 445.964 249.722C443.728 259.43 441.503 267.437 439.853 273.057L443.978 274.83C444.015 274.698 444.05 274.589 444.087 274.457C445.629 268.729 447.734 260.528 449.791 250.578C450.45 247.442 451.095 244.066 451.73 240.605C452.566 240.629 457.291 240.713 461.729 240.231C463.403 244.97 469.707 252.388 470.532 253.339C468.308 255.571 466.118 257.717 464.026 259.707C456.848 266.557 450.605 272.008 446.155 275.771L450.689 277.712C454.935 273.902 460.484 268.788 466.753 262.541C469.024 260.286 471.405 257.838 473.822 255.294C474.862 256.029 483.426 261.974 488.222 262.855C492.563 263.651 498.317 263.458 501.763 260.262C505.135 257.139 505.59 251.712 502.026 248.515C497.074 244.078 485.471 246.912 480.376 249.926C480.076 250.108 477.026 252.412 475.137 253.894C476.118 252.845 477.087 251.844 478.091 250.758C480.076 248.624 482.003 246.43 484.084 244.078C485.053 242.908 486.021 241.727 487.003 240.533C488.007 239.374 488.916 238.012 489.885 236.745C492.073 233.754 494.143 230.62 496.164 227.423C498.018 229.172 504.717 235.31 508.914 236.769C513.089 238.229 518.806 238.904 522.681 236.275C526.486 233.706 527.753 228.401 524.715 224.697C520.493 219.561 508.592 220.573 503.102 222.792C502.755 222.925 498.998 224.963 496.954 226.121C498.149 224.192 499.358 222.261 500.507 220.26C503.831 214.496 507.013 208.549 510.218 202.641C511.2 200.831 512.192 199.034 513.185 197.238C513.843 197.865 521.641 205.33 526.33 206.969C530.505 208.43 536.222 209.104 540.097 206.475C543.901 203.907 545.169 198.6 542.13 194.898C537.908 189.761 526.007 190.774 520.517 192.993C520.099 193.161 514.692 196.092 513.353 196.912C515.541 192.956 517.754 189.025 520.099 185.238C523.316 180.016 526.773 175.072 530.457 170.525C530.755 170.815 538.865 178.641 543.673 180.318C547.848 181.777 553.565 182.452 557.44 179.823C561.244 177.255 562.512 171.948 559.474 168.246C555.252 163.108 543.351 164.121 537.861 166.34C537.502 166.485 533.374 168.716 531.437 169.826C531.306 169.669 531.33 169.693 531.197 169.536C535.205 164.724 539.702 160.564 544.091 156.885C546.627 154.751 549.176 152.845 551.699 151.06C553.062 152.677 559.367 159.973 563.529 161.963C567.524 163.868 573.121 165.183 577.272 163C581.327 160.865 583.169 155.74 580.549 151.724C576.913 146.152 564.976 145.851 559.282 147.431C558.971 147.515 555.921 148.745 553.709 149.674C554.856 148.878 556.029 148.046 557.142 147.31C561.328 144.536 565.323 142.257 568.875 140.267C570.909 139.158 572.763 138.181 574.52 137.3C576.673 138.181 585.405 141.618 589.926 141.449C594.339 141.292 599.914 139.845 602.594 135.986C605.224 132.211 604.507 126.796 600.345 124.445L600.332 124.481Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.775 103.351C250.222 107.15 239.422 111.504 239.422 111.504C239.314 111.552 238.741 103.46 238.765 102.941C239.015 96.9835 242.986 85.6352 249.373 83.8624C253.966 82.5842 258.248 85.9368 259.002 90.4833C259.779 95.1264 256.814 100.107 253.788 103.339L253.775 103.351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.64 152.17C146.569 152.267 141.665 145.839 141.401 145.405C138.352 140.292 135.457 128.618 139.811 123.589C142.944 119.971 148.339 120.381 151.473 123.757C154.666 127.195 154.917 132.995 154.152 137.385C153.267 142.535 146.64 152.17 146.64 152.17Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M500.086 122.25H211.313C207.296 122.25 204.04 125.533 204.04 129.583V567.751C204.04 571.801 207.296 575.085 211.313 575.085H500.086C504.104 575.085 507.359 571.801 507.359 567.751V129.583C507.359 125.533 504.104 122.25 500.086 122.25Z",
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 1.40801,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.942 132.475H219.446V557.644H491.942V132.475Z",
    fill: "white",
    stroke: "#212121",
    strokeWidth: 1.40801,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.753 242.763H414.912",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.004 242.763H377.365",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.359 259.287H414.915",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.81 259.287H348.015",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.004 259.287H269.526",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.524 275.796H414.91",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.004 275.796H290.003",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.492 275.316C471.029 273.03 476.923 263.382 474.656 253.766C472.389 244.15 462.82 238.207 453.283 240.493C443.746 242.779 437.851 252.427 440.118 262.043C442.385 271.659 451.955 277.602 461.492 275.316Z",
    fill: "#22420D",
    stroke: "#212121",
    strokeWidth: 1.40801,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.162 316.4H247.004",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.913 316.4H284.538",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.559 332.924H247.004",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.092 332.924H313.889",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.913 332.924H392.39",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.377 349.432H247.004",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.911 349.432H371.912",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.492 348.958C471.029 346.673 476.923 337.024 474.656 327.408C472.389 317.792 462.82 311.849 453.283 314.134C443.746 316.421 437.851 326.069 440.118 335.685C442.385 345.301 451.955 351.243 461.492 348.958Z",
    fill: "#22420D",
    stroke: "#212121",
    strokeWidth: 1.40801,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.753 390.036H414.912",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.004 390.036H377.365",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.359 406.56H414.915",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.81 406.56H348.015",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.004 406.56H269.526",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.524 423.069H414.91",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.004 423.069H290.003",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.937 417.837C476.869 410.848 476.869 399.516 469.937 392.527C463.007 385.538 451.767 385.538 444.835 392.527C437.903 399.516 437.903 410.848 444.835 417.837C451.767 424.826 463.007 424.826 469.937 417.837Z",
    fill: "#22420D",
    stroke: "#212121",
    strokeWidth: 1.40801,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.635 86.5887C377.355 86.5887 376.314 85.5394 376.314 84.249V71.1039C376.314 68.3542 374.101 66.1352 371.386 66.1352H350.37C347.644 66.1352 345.443 68.3663 345.443 71.1039V84.249C345.443 85.5394 344.402 86.5887 343.122 86.5887C341.842 86.5887 340.802 87.6379 340.802 88.9283V124.529H380.943V88.9283C380.943 87.6379 379.902 86.5887 378.622 86.5887H378.635ZM360.884 85.3586C357.308 85.3586 354.414 82.4401 354.414 78.8342C354.414 75.2283 357.308 72.3099 360.884 72.3099C364.461 72.3099 367.356 75.2283 367.356 78.8342C367.356 82.4401 364.461 85.3586 360.884 85.3586Z",
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 1.40801,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.552 113.216H413.223C418.927 113.216 423.568 117.883 423.568 123.647V135.647H298.218V123.647C298.218 117.895 302.846 113.216 308.563 113.216H308.552Z",
    fill: "white",
    stroke: "#212121",
    strokeWidth: 1.40801,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.315 117.087H420.459C418.306 114.711 415.208 113.216 411.762 113.216H310.023C306.577 113.216 303.479 114.711 301.326 117.087H301.315Z",
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 1.40801,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.557 135.528H298.206V142.897H423.557V135.528Z",
    fill: "white",
    stroke: "#212121",
    strokeWidth: 1.40801,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.628 328.583L455.448 337.228L473.677 319.392",
    stroke: "#C8F7A6",
    strokeWidth: 8.4486,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.628 254.159L455.448 262.806L473.677 244.97",
    stroke: "#C8F7A6",
    strokeWidth: 8.4486,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.753 169.969H414.912",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.004 169.969H377.365",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.359 186.492H414.915",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.81 186.492H348.015",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.004 186.492H269.526",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.524 203.001H414.91",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.004 203.001H290.003",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.928 197.769C476.859 190.78 476.859 179.449 469.928 172.459C462.996 165.47 451.756 165.47 444.824 172.459C437.894 179.448 437.894 190.78 444.824 197.769C451.756 204.759 462.996 204.759 469.928 197.769Z",
    fill: "#22420D",
    stroke: "#212121",
    strokeWidth: 1.40801,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.628 181.367L455.448 190.014L473.677 172.177",
    stroke: "#C8F7A6",
    strokeWidth: 8.4486,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.071 398.795L452.902 407.442L471.119 389.606",
    stroke: "#C8F7A6",
    strokeWidth: 8.4486,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.753 463.869H414.912",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.004 463.869H377.365",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.359 480.377H414.915",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.81 480.377H348.015",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.004 480.377H269.526",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.524 496.901H414.91",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.004 496.901H290.003",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.943 491.657C476.875 484.669 476.875 473.337 469.943 466.348C463.011 459.358 451.773 459.358 444.841 466.348C437.909 473.337 437.909 484.669 444.841 491.657C451.773 498.647 463.011 498.647 469.943 491.657Z",
    fill: "#22420D",
    stroke: "#212121",
    strokeWidth: 1.40801,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.071 472.612L452.902 481.259L471.119 463.434",
    stroke: "#C8F7A6",
    strokeWidth: 8.4486,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.524 566.28H414.91",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.004 566.28H290.003",
    stroke: "#212121",
    strokeWidth: 1.4081,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_91_2004)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.1354,
    y: 235.069,
    width: 106.007,
    height: 106.007,
    rx: 37.2606,
    fill: "#22420D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.139 258.391C86.7473 258.391 73.4567 271.681 73.4567 288.073C73.4567 304.464 86.7473 317.755 103.139 317.755C119.53 317.755 132.82 304.464 132.82 288.073C132.82 271.681 119.53 258.391 103.139 258.391ZM114.832 297.196L112.938 299.78C112.896 299.836 112.844 299.884 112.785 299.92C112.725 299.956 112.659 299.98 112.59 299.99C112.521 300.001 112.451 299.998 112.383 299.981C112.315 299.964 112.252 299.934 112.195 299.892L101.237 291.902C101.169 291.853 101.113 291.788 101.075 291.714C101.037 291.639 101.018 291.556 101.018 291.472V273.232C101.018 272.94 101.257 272.702 101.548 272.702H104.735C105.027 272.702 105.265 272.94 105.265 273.232V289.63L114.713 296.46C114.952 296.626 115.005 296.957 114.832 297.196Z",
    fill: "#97EC5F"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_91_2004)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 554.167,
    y: 354.077,
    width: 97.006,
    height: 97.006,
    rx: 34.097,
    fill: "#22420D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_2004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.338 384.412H619.115V389.079C619.115 389.528 619.027 389.973 618.855 390.389C618.683 390.804 618.431 391.181 618.113 391.499C617.795 391.817 617.418 392.069 617.002 392.241C616.587 392.413 616.142 392.501 615.693 392.501C615.243 392.501 614.798 392.413 614.383 392.241C613.968 392.069 613.59 391.817 613.273 391.499C612.955 391.181 612.703 390.804 612.531 390.389C612.359 389.973 612.27 389.528 612.27 389.079V384.412H594.147V389.079C594.147 389.987 593.786 390.857 593.145 391.499C592.503 392.141 591.632 392.501 590.724 392.501C589.817 392.501 588.946 392.141 588.304 391.499C587.663 390.857 587.302 389.987 587.302 389.079V384.412H581.079C580.709 384.408 580.342 384.478 579.999 384.618C579.657 384.758 579.346 384.966 579.085 385.228C578.823 385.491 578.618 385.803 578.479 386.146C578.341 386.49 578.273 386.858 578.279 387.228V422.043C578.273 422.407 578.339 422.768 578.472 423.106C578.606 423.445 578.804 423.754 579.057 424.015C579.31 424.276 579.612 424.486 579.945 424.63C580.279 424.775 580.638 424.853 581.002 424.859H625.338C625.701 424.853 626.06 424.775 626.394 424.63C626.728 424.486 627.029 424.276 627.282 424.015C627.535 423.754 627.734 423.445 627.867 423.106C628.001 422.768 628.066 422.407 628.06 422.043V387.228C628.066 386.864 628.001 386.503 627.867 386.164C627.734 385.826 627.535 385.517 627.282 385.256C627.029 384.994 626.728 384.785 626.394 384.641C626.06 384.496 625.701 384.418 625.338 384.412ZM590.724 415.525H587.613V412.414H590.724V415.525ZM590.724 407.747H587.613V404.635H590.724V407.747ZM590.724 399.968H587.613V396.857H590.724V399.968ZM600.058 415.525H596.947V412.414H600.058V415.525ZM600.058 407.747H596.947V404.635H600.058V407.747ZM600.058 399.968H596.947V396.857H600.058V399.968ZM609.392 415.525H606.281V412.414H609.392V415.525ZM609.392 407.747H606.281V404.635H609.392V407.747ZM609.392 399.968H606.281V396.857H609.392V399.968ZM618.726 415.525H615.615V412.414H618.726V415.525ZM618.726 407.747H615.615V404.635H618.726V407.747ZM618.726 399.968H615.615V396.857H618.726V399.968Z",
    fill: "#97EC5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.724 390.635C591.137 390.635 591.533 390.471 591.824 390.179C592.116 389.887 592.28 389.492 592.28 389.079V379.745C592.28 379.332 592.116 378.937 591.824 378.645C591.533 378.353 591.137 378.189 590.724 378.189C590.312 378.189 589.916 378.353 589.624 378.645C589.333 378.937 589.169 379.332 589.169 379.745V389.079C589.169 389.492 589.333 389.887 589.624 390.179C589.916 390.471 590.312 390.635 590.724 390.635Z",
    fill: "#97EC5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.615 390.635C616.027 390.635 616.423 390.471 616.715 390.179C617.006 389.887 617.17 389.492 617.17 389.079V379.745C617.17 379.332 617.006 378.937 616.715 378.645C616.423 378.353 616.027 378.189 615.615 378.189C615.202 378.189 614.806 378.353 614.515 378.645C614.223 378.937 614.059 379.332 614.059 379.745V389.079C614.059 389.492 614.223 389.887 614.515 390.179C614.806 390.471 615.202 390.635 615.615 390.635Z",
    fill: "#97EC5F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_91_2004",
    x: 42.4635,
    y: 233.535,
    width: 121.35,
    height: 121.35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.06856
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53428
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_2004"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.53428,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_91_2004"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.13713
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.06856
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_91_2004",
    result: "effect2_dropShadow_91_2004"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_91_2004",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_91_2004",
    x: 547.146,
    y: 352.673,
    width: 111.047,
    height: 111.047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.80803
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.40401
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_2004"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.40401,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_91_2004"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.61605
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.80803
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_91_2004",
    result: "effect2_dropShadow_91_2004"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_91_2004",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_2004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(575.168 375.078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmYourData);
export default __webpack_public_path__ + "static/media/confirm-your-data.3ddad473c2f0b0b419146b0e7f6cd700.svg";
export { ForwardRef as ReactComponent };